function ErrorMessage({ children }) {
  return <small className="text-sm text-danger-500">{children}</small>;
}

export default ErrorMessage;
